<div class="row bg-white p-3 mt-2">
    <div class="col-md-12 text-center">
        <h5 class="text-primary pb-2">
            DOCUMENTS
            <p class="text-danger" *ngIf="required">*</p>
        </h5>
    </div>
    <div _ngcontent-owi-c328="" class="text-danger fw-bold heading mb-2" *ngIf="unAssignedCount > 0"> Documents to be
        assigned <span _ngcontent-owi-c328="" class="badge bg-danger">{{unAssignedCount}}</span></div>
    <div class="data-grid bg-gray table-responsive pb-0">
        <table mat-table [dataSource]="dataSource2" class="table">
            <ng-container matColumnDef="fileName">
                <th mat-header-cell *matHeaderCellDef class="col-2">File Name</th>
                <td mat-cell *matCellDef="let element">
                    {{
                    element.originalFileName
                    }}
                </td>
            </ng-container>
            <!--<ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef class="w-4-rem">Date</th>
              <td mat-cell *matCellDef="let element">
                {{ element.studyStatusDate | date : "medium" }}
              </td>
            </ng-container>-->
            <ng-container matColumnDef="videoType">
                <th mat-header-cell *matHeaderCellDef class="col-2">Doc Type</th>
                <td mat-cell *matCellDef="let element">
                    <span *ngIf="element.documentTypeName">{{ element.documentTypeName }}</span>
                    <span *ngIf="element.documentTypeName && !isInReview" class="float-end"><button
                            class="btn btn-outline-warning btn-sm me-2" type="button"
                            (click)="openDocTypePopup(element,true)"><i class="fa fa-edit"></i></button></span>
                    <button *ngIf="!element.documentTypeName" type="button" class="btn btn-warning btn-sm"
                        (click)="openDocTypePopup(element,true)">Assign</button>
                </td>
            </ng-container>
            <ng-container matColumnDef="details">
                <th mat-header-cell *matHeaderCellDef class="col-1">Format</th>
                <td mat-cell *matCellDef="let element">{{ element.mimeType }}</td>
            </ng-container>
            <ng-container matColumnDef="uploadedby">
                <th mat-header-cell *matHeaderCellDef class="col-2">Uploaded By</th>
                <td mat-cell *matCellDef="let element">{{ element.createdByUser?.name }}</td>
            </ng-container>
            <ng-container matColumnDef="uploadeddate">
                <th mat-header-cell *matHeaderCellDef class="col-2">Uploaded Date/Time</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.createdDate | date }}
                    {{ element.createdDate | date : "hh:mm:ss a" }}
                </td>
            </ng-container>
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef class="col-1">
                    <div class="d-flex align-items-center" *ngIf="isInReview">
                        <mat-checkbox (change)="toggleAllRows()" [checked]="isAllSelected()"
                            [disabled]="isAllDisabled()" [indeterminate]="selection.hasValue() && !isAllSelected()"
                            *ngIf="isSalesCompany">
                        </mat-checkbox>
                        <span class="ms-2">Status</span>
                    </div>
                </th>
                <td mat-cell *matCellDef="let studyFile">
                    <div class="d-flex align-items-center flex-row gap-1">
                        <mat-checkbox *ngIf="isInReview && isSalesCompany" (change)="toggleRow(studyFile)"
                            [disabled]="studyFile.originalStudyStatusId == StudyStatus.Approved || studyFile.originalStudyStatusId == StudyStatus.Denied"
                            [checked]="selection.isSelected(studyFile)"></mat-checkbox>
                        <div class="select-box" [ngClass]="{'w-100':isInReview == false}">
                            <select (change)="onChangeStatus($event, studyFile)" class="form-control custom-form-select dropdown-arrow text-white fs-13 study-status-box study-status-box-{{
                                studyFile.studyStatusId
                              }}"
                                *ngIf="isUserSaleEditor && !isReadOnly && studyFile.originalStudyStatusId != StudyStatus.Denied"
                                [(ngModel)]="studyFile.studyStatusId">

                                <ng-container *ngFor="let status of statuses">
                                    <option
                                        *ngIf="status.id > StudyStatus.Draft"
                                        [value]="status.id">
                                        {{ status.altName }}
                                    </option>

                                </ng-container>
                            </select>
                            <span class="study-status-box form-control study-status-box-{{
                            studyFile.studyStatusId
                          }}"
                                *ngIf="!isUserSaleEditor || isReadOnly || studyFile.originalStudyStatusId == StudyStatus.Denied">
                                {{ studyFile.studyStatus }}
                            </span>
                            <span
                                *ngIf="studyFile.statusMessage && (studyFile.studyStatusId == StudyStatus.Denied ||  studyFile.studyStatusId == StudyStatus.Approved)">
                            </span>
                        </div>
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="comment" *ngIf="isInReview">
                <th mat-header-cell *matHeaderCellDef class="col-1">Comment</th>
                <td mat-cell *matCellDef="let element">
                    <span class="d-block ms-1">{{ element.statusMessage }}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef class="col"></th>
                <td mat-cell *matCellDef="let studyFile" class="white-space-no-wrap">
                    <button class="btn btn-outline-info me-2" (click)="viewPdf(studyFile)">
                        PREVIEW
                    </button>
                    <button class="btn btn-outline-danger" *ngIf="!isInReview"
                        (click)="emitDeleteButtonClicked(studyFile.studyFileId)">
                        REMOVE
                    </button>
                    <button *ngIf="isSalesCompany" class="btn btn-outline-primary"
                        (click)="emitDownloadButtonClicked(studyFile)">
                        <i class="fa fa-download"></i>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns" class="border-start-0 border-end-0 pt-2"></tr>
        </table>
    </div>

</div>
